import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, TicketPercent, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const couponDiscount = (coupon, total) => {
  if (!coupon || total <= 0) return 0;
  const raw = coupon.kind === "percent" ? (total * Number(coupon.value)) / 100 : Number(coupon.value);
  return Math.round(Math.min(raw, total * 0.9) * 100) / 100;
};

export const CouponField = ({ kind, total, coupon, setCoupon }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const apply = async () => {
    if (!code.trim()) return;
    setLoading(true);
    try {
      const r = await axios.post(`${API}/public/coupons/validate`, { code: code.trim(), kind, total });
      setCoupon(r.data);
      toast.success(`Cupom ${r.data.code} aplicado.`);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Cupom inválido");
    }
    setLoading(false);
  };

  if (coupon) {
    return (
      <div className="mb-4 flex items-center justify-between gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2.5 text-sm" data-testid="coupon-applied">
        <span className="flex items-center gap-2 text-emerald-800 font-semibold">
          <TicketPercent size={16} /> {coupon.code} · {coupon.kind === "percent" ? `${coupon.value}% off` : `${Number(coupon.value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} off`}
        </span>
        <button onClick={() => { setCoupon(null); setCode(""); }} aria-label="Remover cupom" className="text-emerald-700 hover:text-red-600" data-testid="coupon-remove"><X size={16} /></button>
      </div>
    );
  }

  return (
    <div className="mb-4 flex gap-2" data-testid="coupon-field">
      <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && apply()}
        placeholder="Cupom de desconto" className="flex-1 min-w-0 p-2.5 rounded-xl border border-slate-200 text-sm uppercase outline-none focus:ring-2 focus:ring-[#0A66C2]" data-testid="coupon-input" />
      <button onClick={apply} disabled={loading || !code.trim()} className="px-4 rounded-xl border border-[#0A66C2] text-[#0A66C2] text-sm font-bold hover:bg-blue-50 disabled:opacity-50" data-testid="coupon-apply">
        {loading ? <Loader2 size={16} className="animate-spin" /> : "Aplicar"}
      </button>
    </div>
  );
};
